import React, {FC} from 'react'
import {PriceProps} from '@/types/productRecommendations'
import {FormattedNumber} from 'react-intl'
import {cn} from '@/lib/utils'

const Price: FC<PriceProps> = ({price, priceMax, className}) => {
    if (!price) {
        return null
    }

    if (typeof price === 'number') {
        const isRangePrice =
            priceMax &&
            typeof priceMax === 'number' &&
            !Number.isNaN(Number(priceMax)) &&
            price < priceMax
        return (
            <div className={cn(className)} data-testid="price-Box">
                {isRangePrice ? (
                    <>
                        <FormattedNumber
                            value={price}
                            style="currency"
                            currency="USD"
                            data-testid="price-FormattedNumber"
                        />{' '}
                        -{' '}
                        <FormattedNumber
                            value={priceMax}
                            style="currency"
                            currency="USD"
                            data-testid="price-FormattedNumber"
                        />
                    </>
                ) : (
                    <FormattedNumber
                        value={price}
                        style="currency"
                        currency="USD"
                        data-testid="price-FormattedNumber"
                    />
                )}
            </div>
        )
    }

    return (
        <div className={cn(className)} data-testid="price-Box">
            {/* Fixed Price */}
            {'type' in price && price.type === 'fixed' && (
                <>
                    {'perUnit' in price && price.perUnit && (
                        <p className="truncate" data-testid="price-Text">
                            {price.perUnit}
                        </p>
                    )}
                    {'startingPrice' in price && price.startingPrice && (
                        <p className="truncate" data-testid="price-Text">
                            <span className="inline-block mr-1 font-light text-gray-500 line-through">
                                {price.startingPrice}
                            </span>
                            {price.discountedPrice}
                        </p>
                    )}
                    {'rangeStart' in price && price.rangeStart && (
                        <p className="truncate" data-testid="price-Text">
                            {price.rangeStart} - {price.rangeEnd}
                        </p>
                    )}
                </>
            )}
            {/* Range Price */}
            {'type' in price && price.type === 'range' && (
                <p className="truncate" data-testid="price-Text">
                    {price.min.sales.formatted} - {price.max.sales.formatted}
                </p>
            )}
            {/* Simple Price */}
            {'sales' in price && (
                <p className="truncate" data-testid="price-Text">
                    {price.list && (
                        <span className="inline-block mr-1 font-light text-gray-500 line-through">
                            {price.list.formatted}
                        </span>
                    )}
                    {price.sales.formatted}
                </p>
            )}
        </div>
    )
}

export default Price
